import {isNotNil} from 'ramda';

import {type CheckoutProfile} from '@dms/api/sales';

import type {CheckoutProfileFormValues} from '../types/CheckoutProfileFormValuesSchema';

export function getCheckoutProfileFormValues(
  profile?: CheckoutProfile,
  branchId = ''
): CheckoutProfileFormValues {
  if (isNotNil(profile)) {
    const documents = profile.documents.map((row) => ({
      ...row,
      restrictSeries: row.allowedSeriesIds.length > 0,
      restrictTemplates: row.allowedTemplateIds.length > 0,
    }));

    if (profile.typeOfSale === 'INTERNAL') {
      return {
        name: profile.name,
        branchId: profile.branchId,
        typeOfSale: profile.typeOfSale,
        isActive: profile.isActive,
        documentTypes: profile.documentTypes ?? {},
        documents,
      };
    }

    return {
      name: profile.name,
      branchId: profile.branchId,
      typeOfSale: profile.typeOfSale,
      isActive: profile.isActive,
      saleRegimes: profile.saleRegimes ?? {inEurope: false, outOfEurope: false},
      foreignCurrency: profile.foreignCurrency ?? {isAllowed: false, isDefault: false},
      payments: {
        isMethodChangeAllowed: true,
        ...profile.payments,
        methods: profile.payments?.methods ?? [],
      },
      deposit: profile.deposit ?? {isAllowed: false, isMethodChangeAllowed: true, methods: []},
      documentTypes: profile.documentTypes ?? {},
      documents,
    };
  }

  return {
    name: '',
    branchId,
    typeOfSale: 'DEFAULT',
    isActive: false,
    saleRegimes: {inEurope: false, outOfEurope: false},
    foreignCurrency: {isAllowed: false, isDefault: false},
    payments: {isMethodChangeAllowed: true, methods: []},
    deposit: {isAllowed: false, isMethodChangeAllowed: true, methods: []},
    documentTypes: {correctiveInvoice: false, correctiveTaxDocument: false},
    documents: [],
  };
}
